<h2 mat-dialog-title>Leave the Page?</h2>

<mat-dialog-content>
  <p>
    Don't worry, your order will still be here when
    you come back.
  </p>
</mat-dialog-content>

<mat-dialog-actions class="fx-layout-row fx-align--space-between-x">
  <button mat-flat-button color="primary" mat-dialog-close="stay">Stay</button>
  <button mat-flat-button color="secondary" mat-dialog-close="leave">Leave</button>
</mat-dialog-actions>
